import React from "react";
import style from "./ReadOnlyBanner.module.scss";
import constants from "../../../constants/constants.json";

export const ReadOnlyBanner = () => {
  return (
    <div className={style.info_banner}>
      <div className={`alert alert-warning ${style.info_banner_content}`}>
        <i className="fa fa-eye mr-2" />
        {constants.assessment.readOnlyBanner}
      </div>
    </div>
  );
};
